import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

constructor(private httpClient: HttpClient) { }

HttpGetWithCredentials<T>(url: string): any {
  // this.alertService.startProgressBar();

  let tokenString = '';

  let httpHeaders = new HttpHeaders();

  const securityToken: string = localStorage.getItem('token');

  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
      .set('If-Modified-Since', '0');
  }

  console.log('url=' + url);

  return this.httpClient.get<T>(url, {withCredentials: true, headers: httpHeaders, observe: 'response' })
    .pipe(
      catchError((err) => this.handleError(err)),
      finalize(() => {
        console.log('finalized');
      })
    );
}

public handleError(error: HttpErrorResponse) {

  // console.log('handle error');

  if (error.error instanceof Error) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error.message);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    // console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
  }
  return throwError(error);
}
}